import styled from 'academy-common-lib/utils/Styling';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import { useTrackProgress } from '../../userProgress/userProgressQueries';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapTrackViewAwardLink = styled(TrackViewAwardLink).withConfig({
  displayName: "LearningContentCardAwardLink__NoWrapTrackViewAwardLink"
})(["white-space:nowrap;margin-left:18px;margin-bottom:1px;"]);
export const LearningContentCardAwardLink = ({
  trackId,
  use = 'on-dark'
}) => {
  const {
    trackProgress
  } = useTrackProgress(trackId);
  const award = trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.award;
  if (!award || award.isExpired) return null;
  return /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(NoWrapTrackViewAwardLink, {
      award: award,
      certification: true,
      likeLink: true,
      trackId: trackId,
      use: use,
      useButton: false
    })
  });
};
export default LearningContentCardAwardLink;